const imageLinks = [
	require('./assets/aipreview1.png'),
	require('./assets/aipreview2.png'),
	require('./assets/aipreview3.png'),
	require('./assets/aipreview4.png'),
	require('./assets/aipreview5.png'),
	require('./assets/aipreview6.png'),
	require('./assets/aipreview7.png'),
	//"src/logged_out/components/updated_frontpage/assets/20221124_164829.jpg"
];

export default imageLinks;
